export enum OrgDataFilterKey {
  CURRENT_USER = 'current_user',
  ALL = 'all',
}
